import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "qin-form qin-form--auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "qin-form__logo",
  src: "/static/app/quod-logo.png",
  alt: "ls-logo-image"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "qin-form__title" }
const _hoisted_5 = {
  key: 0,
  class: "ds-caption ds-caption--size_3xl ds-caption--bold"
}
const _hoisted_6 = {
  key: 1,
  class: "ds-caption ds-caption--size_3xl ds-caption--bold ds-caption--appearance_center"
}
const _hoisted_7 = {
  key: 0,
  class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey"
}
const _hoisted_8 = { class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey ds-caption--appearance_center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ds-panel ds-panel--space_2xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ds-panel__element ds-panel__element--offset_bottom" })
], -1)
const _hoisted_10 = { class: "qin-form__wrapper" }
const _hoisted_11 = { class: "error-label" }
const _hoisted_12 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols g-cols--12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "qin-button qin-button--main qin-button--accent qin-button--full_width qin-button--offset_horisontal-md",
    type: 'submit'
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "qin-button__text" }, /*#__PURE__*/_toDisplayString('Reset Password'))
  ])
], -1)
const _hoisted_15 = {
  key: 1,
  class: "g-cell g-cols g-cols--12"
}
const _hoisted_16 = { class: "check-icon-wrapper" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ds-panel ds-panel--space_lg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ds-panel__element ds-panel__element--offset_bottom" })
], -1)
const _hoisted_18 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_19 = { class: "recaptcha-field g-recaptcha" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_i_check_circle = _resolveComponent("i-check-circle")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.load)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["qin-form__logo-wrapper", {'qin-form__logo-wrapper--centered' : $setup.emailIsSended}])
    }, _hoisted_3, 2),
    _createElementVNode("div", _hoisted_4, [
      (!$setup.emailIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.$t('Reset Password')), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.$t('Successfully')), 1))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["qin-form__subtitle", {'centered' : $setup.emailIsSended}])
    }, [
      (!$setup.emailIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.$t("Enter your email address and we'll send you an email with instructions to reset your password.")), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.$t("Successfully sent recovery url. Check your mail box.")), 1),
            _hoisted_9
          ], 64))
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_VeeForm, {
        onSubmit: $setup.request,
        ref: "form"
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            (!$setup.emailIsSended)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_d_control_input, {
                      rules: "required|email|max:255",
                      name: "email",
                      type: "text",
                      "input-label": $setup.$t("E-mail"),
                      modelValue: $setup.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
                    }, null, 8, ["input-label", "modelValue"])
                  ]),
                  _hoisted_14
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_i_check_circle)
                  ]),
                  _hoisted_17
                ])),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", {
                class: "ds-caption ds-caption--color_accent ds-caption--size_sm hovered_underline",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.toResetForm()), ["prevent"]))
              }, _toDisplayString($setup.$t('Back to Log In')), 1)
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_19, [
        _createVNode($setup["vueRecaptcha"], {
          size: "invisible",
          sitekey: $setup.key,
          onVerify: _cache[2] || (_cache[2] = ($event: any) => ($setup.recaptchaVerified($event, $setup.request))),
          ref: "recaptcha"
        }, null, 8, ["sitekey"])
      ])
    ])
  ]))
}